import React, { Fragment } from 'react';

export const giftCardsList = [
  {
    number: '1',
    text: (
      <Fragment>
        Traga <b>1 amiga</b> e ganhe <b>Óleo Corporal Natura Sève</b>
      </Fragment>
    ),
    img: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21056.png',
    backgroundColor: '#ffcdd0',
  },
  {
    number: '2',
    text: (
      <Fragment>
        Traga <b>2 amigas</b> e ganhe <b>Supermáscara para Cílios Natura Faces</b>
      </Fragment>
    ),
    img: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21058.png',
    backgroundColor: '#ffcdd0',
  },
  {
    number: '3',
    text: (
      <Fragment>
        Traga <b>3 amigas</b> e ganhe <b>Sabonete facial Natura Faces</b>
      </Fragment>
    ),
    img: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21057.png',
    backgroundColor: '#ffcdd0',
  },
  {
    number: '4',
    text: (
      <Fragment>
        Traga <b>4 amigas</b> e ganhe <b>Paleta de Sobrancelhas Bella & Brava</b>
      </Fragment>
    ),
    img: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21059.png',
    backgroundColor: '#ffcdd0',
  },
  {
    number: '5',
    text: (
      <Fragment>
        Traga <b>5 amigas</b> e ganhe <b>Paleta Iluminadora Bella & Brava</b>
      </Fragment>
    ),
    img: 'https://s3.amazonaws.com/Glambox.Content.MediaObject/MediaFile_21060.png',
    backgroundColor: '#ffcdd0',
  },
];
